import {
  Input,
  useControllableProp,
  useFormControlContext,
} from '@chakra-ui/react';
import * as React from 'react';

export const FreeText = React.forwardRef<
  HTMLInputElement,
  {
    value: string;
    onChange: (value: string) => void;
    onBlur?: () => void;
    isDisabled?: boolean;
    autoFocus?: boolean;
  }
>((props, ref) => {
  const formControlContext = useFormControlContext();

  const [, isDisabled] = useControllableProp(
    props.isDisabled ? true : undefined,
    formControlContext?.isDisabled
  );

  return (
    <Input
      value={props.value}
      onChange={(event) => props.onChange(event.target.value)}
      onBlur={props.onBlur}
      ref={ref}
      isDisabled={isDisabled}
      autoFocus={props.autoFocus}
      bg="white"
    />
  );
});

FreeText.displayName = 'FreeText';
